import React from 'react';
import './SponsorsSection.css';

const SponsorsSection = () => {
  const logoData = [
    { id: 1, name: 'Marca Participante 1' },
    { id: 2, name: 'Marca Participante 2' },
    { id: 3, name: 'Marca Participante 3' },
    { id: 4, name: 'Marca Participante 4' },
    { id: 5, name: 'Marca Participante 5' },
    { id: 6, name: 'Marca Participante 6' },
    { id: 7, name: 'Marca Participante 7' },
    { id: 8, name: 'Marca Participante 8' },
    { id: 9, name: 'Marca Participante 9' },
    { id: 10, name: 'Marca Participante 10' },
    { id: 11, name: 'Marca Participante 11' },
    { id: 12, name: 'Marca Participante 12' },
    { id: 13, name: 'Marca Participante 13' },
    { id: 14, name: 'Marca Participante 14' },
    { id: 15, name: 'Marca Participante 15' },
    { id: 16, name: 'Marca Participante 16' },
    { id: 17, name: 'Marca Participante 17' },
    { id: 18, name: 'Marca Participante 18' }
  ];

  return (
    <section id="marcas" className="sponsors-section">
      <div className="container">
        <h2 className="section-title">Marcas Oficiales Participantes</h2>
        <p className="sponsors-subtitle">
          Conoce a las empresas y marcas que hacen posible la Fiesta del Tendero
        </p>
        
        <div className="sponsors-grid">
          {logoData.map((logo) => (
            <div key={logo.id} className="sponsor-item">
              <div className="sponsor-logo-container">
                <img
                  src={`/logos/${logo.id}.png`}
                  alt={logo.name}
                  className="sponsor-logo"
                  loading="lazy"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            </div>
          ))}
        </div>
        
        <div className="sponsors-footer">
          <p>
            <strong>¡Gracias a todas las marcas participantes por hacer posible este gran evento!</strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default SponsorsSection;